<ng-container *ngIf="routerData$ | async as routerData">
  <ng-container *ngIf="configurationOverview$ | async">
    <div
      class="cx-error-notification-banner"
      *ngIf="numberOfIssues$ | async as numberOfIssues"
    >
      <cx-icon [type]="iconTypes.ERROR"></cx-icon>
      <div class="cx-error-msg" id="cx-configurator-overview-error-msg">
        {{
          'configurator.notificationBanner.numberOfIssues'
            | cxTranslate: { count: numberOfIssues }
        }}
        <button
          class="link cx-action-link"
          aria-describedby="cx-configurator-overview-error-msg"
          [routerLink]="
            {
              cxRoute: 'configure' + routerData.owner.configuratorType,
              params: {
                entityKey: routerData.owner.id,
                ownerType: routerData.owner.type,
              },
            } | cxUrl
          "
          [queryParams]="{
            resolveIssues: true,
            skipConflicts: skipConflictsOnIssueNavigation$ | async,
            productCode: routerData.productCode,
          }"
          cxAutoFocus
        >
          {{ 'configurator.header.resolveIssues' | cxTranslate }}
        </button>
      </div>
    </div>
    <div
      class="cx-conflict-notification-banner"
      *ngIf="numberOfConflicts$ | async as numberOfConflicts"
    >
      <cx-icon [type]="iconTypes.WARNING"></cx-icon>
      <div class="cx-conflict-msg" id="cx-configurator-overview-conflict-msg">
        {{
          'configurator.notificationBanner.numberOfConflicts'
            | cxTranslate: { count: numberOfConflicts }
        }}
        <button
          class="link cx-action-link"
          aria-describedby="cx-configurator-overview-conflict-msg"
          [routerLink]="
            {
              cxRoute: 'configure' + routerData.owner.configuratorType,
              params: {
                entityKey: routerData.owner.id,
                ownerType: routerData.owner.type,
              },
            } | cxUrl
          "
          [queryParams]="{
            resolveIssues: true,
            productCode: routerData.productCode,
          }"
          cxAutoFocus
        >
          {{ 'configurator.header.resolveConflicts' | cxTranslate }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>
